import BaseModel from "./BaseModel";

export default class Jobs extends BaseModel {
	constructor(restApi) {
		super(restApi, "Jobs", null);
		
		this.restApi = restApi;
	}
	
	static moduleSingular() {
		return "Job";
	}
	
	static modulePlural() {
		return "Jobs";
	}
  
  static nameMapping() {
    return [
      
    ];
  }
	
	static createModel(restApi, jsonObject) {
		return BaseModel.createModel(Jobs, restApi, jsonObject, Jobs.nameMapping());
	}
}



// WEBPACK FOOTER //
// ./src/modules/Jobs.js